import { render } from "./app-logo-cryptopay.vue?vue&type=template&id=37a27e98"
const script = {}

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/image/app-logo-cryptopay.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "37a27e98"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('37a27e98', __exports__)) {
    console.log('reload')
    api.reload('37a27e98', __exports__)
  }
  
  module.hot.accept("./app-logo-cryptopay.vue?vue&type=template&id=37a27e98", () => {
    console.log('re-render')
    api.rerender('37a27e98', render)
  })

}


export default __exports__